import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'hasLocation'
})
export class HasLocationPipe implements PipeTransform {

  transform(items: any[]): any {
    let location = _.find(items, { kind: 'location' });
    if (!_.isNil(location)) {
      return true;
    } else {
      return false;
    }
  }

}